import React from 'react';
import MainLayout from './MainLayout';

function ContentLayout({ contentHeader, children }) {
	return (
		<MainLayout>
			
				<div className='page-content'>
					{contentHeader && <h1 className='content-header'>{contentHeader}</h1>}
					{children}
			</div>
		</MainLayout>
	);
}

export default ContentLayout;
